export default __webpack_public_path__ + "static/media/mockup.0779013f.png";